import Script from 'next/script'
import { getSections } from './utils'
import { IChartbeat } from './types'
import min from '@/utils/text/min'

const Chartbeat = ({ layoutData, path }: IChartbeat) => {
    if (!path) return null
    const chartbeatPaths = ['/news/', '/tv-video/video/']
    const isHome = path === '/'
    const isTvHome = path === '/tv'
    const isChartbeatPaths = chartbeatPaths.some(value => path.startsWith(value))
    const shouldLoad = isHome || isTvHome || isChartbeatPaths
    const sections = getSections(layoutData)
    return (
        <>
            <Script
                strategy="afterInteractive"
                id="chartbeat_config"
                type="text/javascript"
                dangerouslySetInnerHTML={{
                    __html: min(`
                            console.debug('Chartbeat (FE) - Startup for:', '${path}');
                            if(${shouldLoad}){
                            /** CONFIGURATION START **/
                            console.debug('Chartbeat (FE) - loading');
                            var _sf_async_config = window._sf_async_config = (window._sf_async_config || { });
                            _sf_async_config.uid = 50862;
                            _sf_async_config.domain = "sport1.de";
                            _sf_async_config.flickerControl = false;
                            _sf_async_config.useCanonical = true;
                            _sf_async_config.useCanonicalDomain = true;
                            if ('${sections}'){
                            _sf_async_config.sections = "${sections}";
                            console.debug('Chartbeat - sections:"${sections}"');
                            }
                            /** CONFIGURATION END **/
                    } else {
                            console.debug("Chartbeat (FE) - not loaded (we support home (/ and /tv), video and news)");
                    }
                    `),
                }}
            />
            {shouldLoad && (
                <Script
                    id="chartbeat-script"
                    strategy="afterInteractive"
                    async
                    src="//static.chartbeat.com/js/chartbeat_mab.js"
                />
            )}
        </>
    )
}

export default Chartbeat
